<div *ngIf="this.screenView[this.index]==3">
    <div class="container">
        <div class="basicrow allpads f-reg roboto-r f-black">
            <div class="basicrow text-center m-top-u">
                <div class="basicrow">
                    Su reporte ha sido creado exitosamente.
                </div>
                <div class="basicrow roboto-b m-top">
                    Reportado: {{this.respuesta[2]}}
                </div>
            </div>

            <div class="basicrow m-top-i">
                <div class="logline full"></div>
            </div>

            <div class="basicrow m-top">
                <a (click)="this.close(this.index)" class="btns def-i red centr vcenter">
                    <span class="tabcell">
						Ok
					</span>
                </a>
            </div>
        </div>
    </div>
</div>